import { createFeatureSelector, createSelector } from "@ngrx/store";

import { State as contactUsInfoState } from "../reducers/contactus"
import * as widgetConfigSelectors from "../../widget-configs/selectors/widget-configs";
import { WidgetConfiguration } from "../../widget-configs/models/widget-configuration";

export const selectContactUsInfoState = createFeatureSelector<contactUsInfoState >('contactInfo');


export function getContactInfo(widgetConfigId: number) {
  return createSelector(
    [selectContactUsInfoState, widgetConfigSelectors.selectEntityByWidgetConfigId(widgetConfigId)],
    (contactUsState: contactUsInfoState, widgetConfiguration: WidgetConfiguration) => {
      if (widgetConfiguration && widgetConfiguration.selectedManagerCodes) {
        const filteredContactInfo = contactUsState.contactInfo.filter(x => {
          return x.ManagerTypeCode == undefined || (widgetConfiguration.selectedManagerCodes.indexOf(x.ManagerTypeCode) > -1);
        });
        return filteredContactInfo;
      }
      return contactUsState.contactInfo;
    });
}

export const getError = createSelector(
  [selectContactUsInfoState],
  (contactUsState: contactUsInfoState ) => {
    return contactUsState.error;
  }
);

export const getManagementTypes = createSelector(
  [selectContactUsInfoState],
  (contactUsState: contactUsInfoState) => {
    return contactUsState.managementTypesForAdmin;
  }
);


export const getLoading = createSelector(
  [selectContactUsInfoState],
  (contactUsState: contactUsInfoState) => {
    return contactUsState.loading;
  }
);
